import {css} from 'lit';
export const styles = css`:host([theme='one']) main {
  display: block;
  padding: 5px;
  background-color: var(--warning-000);
  color: var(--warning-800);
  text-align: center;
  opacity: 0;
  transition: opacity 0.4s linear;
}

:host([theme='one'][online]) main {
  background-color: var(--primary-800);
  color: var(--light-text);
}
`;
export default styles;
